const state = {
    chats: [],
    messages: []
}

export default state
